import { X, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

export default function QuickViewModal({ product, onClose }) {
  const { addItem } = useCart();
  if (!product) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="quick-view-modal">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative liquid-glass-panel rounded-[2rem] max-w-3xl w-full overflow-hidden grid md:grid-cols-2 max-h-[90vh] overflow-y-auto">
        <button onClick={onClose} className="absolute top-4 right-4 z-10 bg-white/90 rounded-full p-2" data-testid="quick-view-close" aria-label="Chiudi"><X size={20} strokeWidth={1.5} /></button>
        <img src={product.images[0]} alt={product.name} className="w-full h-72 md:h-full object-contain p-6 bg-essenya-surface2" />
        <div className="p-8 space-y-3">
          <div className="text-eyebrow">{product.categoryLabel} · {product.fragranceLabel}</div>
          <h3 className="font-display text-2xl">{product.name}</h3>
          <p className="text-essenya-text text-sm">{product.subtitle}</p>
          <div className="flex items-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => <Star key={i} size={14} strokeWidth={1.5} className={i < Math.round(product.rating) ? 'fill-essenya-ink text-essenya-ink' : 'text-essenya-border'} />)}
            <span className="text-xs text-essenya-text ml-1">({product.reviews})</span>
          </div>
          <p className="text-sm">{product.short}</p>
          <div className="font-display text-2xl pt-2">{product.price.toFixed(2).replace('.', ',')}€</div>
          <div className="flex gap-2 pt-2">
            <button onClick={() => { addItem(product.id); toast.success('Aggiunto al carrello'); onClose(); }} className="btn-primary flex-1" data-testid="quick-view-add-to-cart">Aggiungi</button>
            <Link to={`/prodotto/${product.slug}`} onClick={onClose} className="btn-secondary">Dettagli</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
